/**
 * Date du prochain JLPT.
 *
 * Le JLPT a lieu deux fois par an : le premier dimanche de juillet et le
 * premier dimanche de décembre. Cette fonction renvoie la prochaine de ces
 * deux dates encore à venir par rapport à la date passée en paramètre
 * (par défaut : maintenant).
 */

const MOIS_FR = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

function firstSundayOf(year, month /* 1-12 */) {
  // Local time (Europe/Paris pour l'utilisateur cible), on ne se soucie que
  // du jour donc pas de piège timezone/heure.
  const d = new Date(year, month - 1, 1);
  const dow = d.getDay(); // 0 = dimanche
  const daysUntilSunday = (7 - dow) % 7;
  d.setDate(1 + daysUntilSunday);
  return d;
}

export function getNextJLPT(today = new Date()) {
  const y = today.getFullYear();
  const candidates = [
    firstSundayOf(y, 7),      // juillet de l'année en cours
    firstSundayOf(y, 12),     // décembre de l'année en cours
    firstSundayOf(y + 1, 7),  // juillet de l'année suivante (fallback)
    firstSundayOf(y + 1, 12), // décembre de l'année suivante (fallback ultime)
  ];
  // Comparaison sur la date (année/mois/jour) : le JLPT du jour même est
  // considéré comme passé, on renvoie la session suivante.
  const todayYMD = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  for (const c of candidates) {
    if (c > todayYMD) return c;
  }
  return candidates[candidates.length - 1];
}

/** Format court : "6 décembre" (jour, mois en minuscules, sans année).
 *  L'espace entre le chiffre et le mois est insécable (\u00A0) pour que
 *  la date ne soit jamais coupée en fin de ligne. */
export function jlptDateShort(date = getNextJLPT()) {
  return `${date.getDate()}\u00A0${MOIS_FR[date.getMonth()]}`;
}

/** Format long : "6 DÉCEMBRE 2026" (jour, mois en majuscules, année).
 *  Espaces insécables entre les 3 tokens pour rester atomique. */
export function jlptDateLong(date = getNextJLPT()) {
  return `${date.getDate()}\u00A0${MOIS_FR[date.getMonth()].toUpperCase()}\u00A0${date.getFullYear()}`;
}
